import ArticlePage from "~/components/knowledge-base/ArticlePage"

export default ArticlePage
